<template>
    <div class="info animate slideInRight">
        <span class="close show" @click="closed"></span>
        <div class="logInfo">
            <span class="tit show">找回密码</span>
            <input class="inputcls click" @focus="focusfns" @blur="blurfns(1)" :class="isverName ? 'wrong' : ''" value="" v-model="ver" :placeholder=" verName " />
            <div class="fleft codeYz click">
                <span class="codeBtn show fleft f24 cur" @click="getCode">{{ istime ? times+'秒后重发' : codeName}}</span>
                <input class="putcode fright" value="" @focus="focusfns" @blur="blurfns(2)" :class="iscode ? 'wrong' : ''"  v-model="vercode" :placeholder=" $t('lan.entercode') " />
                <span if="isCorrect" class="f20" style="position:absolute; top:0; right:15px; color:#0f9ee6; line-height:45px;">{{codejudge}}</span>
                
            </div>
            <div class="codeYz fleft m20B" style="height:75px; " id="tpyzm" v-if="isToyzm" >
                <form action="" method="POST" id="UserLoginFroms">
                    <div class="g-recaptcha" data-callback="robotVerified" data-sitekey="6Let7aUUAAAAADayc8HFOa0bKlEb3mQ5vr5U3ddT"></div>
                </form>
                <remote-script src="https://www.recaptcha.net/recaptcha/api.js"></remote-script>
                <remote-script src="https://static.lanniuzai.com/js/jquery.form.js"></remote-script>
            </div>
            <div class="fleft codeYz">
                <span class="btnsub show fleft cur" @click="toLog">下一步</span>
                
            </div>
            <p class="js" @click="checkVer">{{ isver ? '切换手机验证》' : '切换邮箱验证》' }}</p>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { Dialog } from 'vant';
Vue.use(Dialog);

export default {
    name: 'app',
    components: {

    },
    props:{

    },
    data(){
        return {
            isver:false,
            lang: window.location.href.indexOf('bluejeanimages')>0 ? 1 : 0,
            codeName:'',
            verName:'',
            timer:0,
            times:'60',
            istime:false,
            vercode:'',
            ver:'',
            isverName:false,
            isToyzm:false,
            isreg:false,
            iscode:false,
            timer:0,
            times:'60',
            isCorrect:false,
            codejudge:'',
        }
    },
    created() {
        this.codeName=(this.lang==1) ? this.$t('lan.telcode') : this.$t('lan.mailcode');
        this.verName=this.isver ?  this.$t('lan.email') :  this.$t('lan.mobtel') ;
        window.robotVerified = (resp)=>{
            console.log(resp+'get a callback');
            this.robotVerified(resp);
        }
        
    },
    mounted(){

    },
    destroyed(){
    
    },
    methods:{
        closed(){
            this.$emit('closeED',true)
        },
        toLog(){
            
            var ver=this.ver;
            var vercode=this.vercode;
            if(ver === '' || ver === ''){
                this.isverName = (ver ==='') ? true : false;
                this.iscode = (vercode ==='') ? true : false;
                return;
            }
            if(this.isVer){
                this.checkmialVer();
            }else{
                this.checknote();
            }
            
            this.$emit('closeType',4);
        },
        checkVer(){
            this.isver=!this.isver;
            this.verName=this.isver ?  this.$t('lan.email') :  this.$t('lan.mobtel') ;
        },
        getCode(){
            if(this.isVer){
                this.checkMail();
            }else{
                this.checkTel();
            }
        },
        focusfns(){
            this.isverName=false;
            this.iscode=false;
        },
        blurfns(type){
            if(type==1){
                if(this.ver==''){
                    this.isverName=true;
                }else{
                    this.isverName=false;
                }
            }else{
                if(this.vercode==''){
                    this.iscode=true;
                }else{
                    this.iscode=false;
                
                }
            }
        },
        //验证手机
        checkTel(){
            var phone = this.ver;
            var pattern = /^1[0-9]{10}$/;
            if(phone == '') {
                this.isverName=true;
                return;
            }
            if(!pattern.test(phone)){
                this.isverName=true;
                this.verName='请输入正确的手机号码';
                return;
            }
            var data = qs.stringify({
                mobile: phone,   
            });
            this.$axios.post(API.log.checkMobile,data).then((res)=>{
                var res = res.data; 
                if( res.result==0){  
                    this.isreg=true;
                    this.recapt();
                }else if(res.result==1){
                    this.isverName=true;
                    this.verName='该手机号未注册';
                    return;
                }
            }).catch((err)=>{
                
                console.log("请求失败") 
            })
        },
        //验证邮箱
        checkMail(){
            var email=this.ver;
            //eileen.lee@sg.leoburnett.com
            var reg = /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_.-])+((\.[a-zA-Z0-9_-]{2,9}){1,2})$/

            if (email == '') {
                this.isverName=true;
                return;
            } else if (!reg.test(email.val())) {
                this.isverName=true;
                this.verName=this.$t('lan.gsName');
                return;
            }
            var data = qs.stringify({
                email: email,  
            });
            this.$axios.post(API.log.checkEmail,data).then((res)=>{
                var res = res.data; 
                if( res.result==1){  
                this.isreg=true;
                this.mailVerified();
                }else if(res.result==0){
                this.isverName=true;
                this.verName='此邮箱未注册';
                return;
                }
            }).catch((err)=>{
                console.log("请求失败") 
            })
        },
        //发送邮件
        mailVerified(id){
            var data = qs.stringify({
                authcodeType:"restPwd",
                email:this.ver  
            });
            this.$axios.post(API.log.sendEmailAuthcode,data).then((res)=>{
                var res = res.data; 
                if( res.result==1){  
                this.isreg=true;
                }else if(res.result==0){
                this.isverName=true;
                this.verName=this.$t('lan.mailerror');
                return;
                }
            }).catch((err)=>{
                console.log("请求失败") 
            })
            this.cleartime();
            this.times='600';
            settime(600,id);
        },
        cleartime(){
            this.istime=true;
            clearInterval(this.timer);
        },
        //人机验证码
        recapt(id){
            this.isToyzm=true;
        },
        //人机验证 后 返回接口
        robotVerified(data){
            if(!data){
                return;
            }
            var recaptcha=data;
            var id='pwdNode';
            var data = qs.stringify({
                smsType:"authcodeResetPwd",
                mobile:this.ver ,
                'g-recaptcha-response' : recaptcha
            });
            this.$axios.post(API.log.sendSmsAuthcode,data).then((res)=>{
                var res = res.data; 
                if( res.code==1){  
                    this.isreg=true;
                    this.cleartime();
                    this.times='120';
                    this.settime();
                }else if(res.code==0){
                    Dialog.alert({
                        title: '温馨提示',
                        message: res.msg,
                    });
                    this.isverName=true;
                    return;
                }
            }).catch((err)=>{
                console.log("请求失败") 
            })
            //验证码有效时间2分钟，验证码有效时间内不能再次发送。
                // 单个ip地址一天10条短信验证码，单个手机号每天5条
            
        },
        settime(){
            this.timer = window.setInterval(()=>{
                this.times --;
                if(this.times <= 0 ){
                    clearInterval(timer);
                    this.istime=false;
                }
            },1000);
        },
        //短信验证码判断
        checknote(){
            var code=this.vercode;
            var data = qs.stringify({
                mobile: this.ver,       
                smsAuthcode: code 
            });
            this.$axios.post(API.log.hasSmsAuthcode,data).then((res)=>{
                var res = res.data; 
                if( res.code==1){  
                    this.isCorrect=true;
                    this.codejudge='√';
                    var obj={'tell':this.ver,'yzm':this.vercode,'yzType':2}
                    this.$emit('closePwd',obj);
                }else if(res.code==0){
                    this.isCorrect=false;
                    this.codejudge=this.$t('lan.codeerror');
                    return;
                }
            }).catch((err)=>{
                console.log("请求失败") 
            })
        },
        //邮箱验证码判断
        checkmialVer(){
            var code=this.vercode;
            var data = qs.stringify({
                email: this.ver,       
                authcode: code 
            });
            this.$axios.post(API.log.hasEmailAuthcode,data).then((res)=>{
                var res = res.data; 
                if( res.code==1){  
                    this.isCorrect=true;
                    this.codejudge='√';
                    var obj={'tell':this.ver,'yzm':this.vercode,'yzType':1}
                    this.$emit('closePwd',obj);
                }else if(res.code==0){
                    this.isCorrect=false;
                    this.codejudge=this.$t('lan.codeerror');
                    return;
                }
            }).catch((err)=>{
                console.log("请求失败") 
            })
        },
    }
}
</script>
<style lang="scss" scoped>
    .info{
      width:750px;
      margin:0 auto;
      background: #fff;
      height:100%;
      position: fixed;
      top:0;
      left: 0;
      z-index:1010;
      color:#000;
    }
    .logInfo{
      width:670px;
      height:700px;
      position:absolute;
      top:50%;
      left:50%;
      margin:-350px 0 0 -335px;
      font-size:36px;
      .tit{
        width:100%;
        line-height:120px;
        font-size:36px;
        text-align: center;
        border-bottom:solid 1px #cbcbcb;
      }
      .inputcls{
        width:630px;
        height:78px;
        line-height:78px;
        padding:30px 20px;
        margin-bottom:2px;
        border-bottom:solid 1px #cbcbcb;
        font-size:36px;
      }
      .inputcls.click{
        border-bottom:solid 3px #00a8ff; 
      }
      .btnsub{
        width:100%;
        height:100px;
        line-height:100px;
        background:#00a8ff;
        color:#fff;
        text-align: center;
      }
      .js{
        font-size:30px;
        line-height:70px;
        text-align: center;
        float: left;
        width:100%;
      }
      .verify{
        height:70px;
        width:100%;
        color:#fff;
        float: left;
        span{
          width:200px;
          height:100%;
          background:#989898;
          display: block;
          line-height:70px;
          text-align: center;
          font-size:26px;
          margin-right:1px;
          float: left;
        }
        .click{
          background:#666;
        }
      }
      .codeYz{
        width:100%;
        height:138px;
        overflow: hidden;
        line-height:70px;
      }
      .codeYz.click{
        border-bottom:solid 1px #cbcbcb;
        margin-bottom:40px;
      }
      .putcode{
        width:330px;
        height:98px;
        background: rgba(255,255,255,.9);
        padding:0 20px;
        font-size:36px;
        line-height:98px;
        margin:20px 0;
        color:#999;
        letter-spacing: 4px;
      }
      .codeBtn{
        width:248px;
        height:120px;
        background:#00a8ff;
        text-align: center;
        line-height:120px;
        color:#fff;
        margin-top:8px;
        font-size:30px;
        letter-spacing: 4px;
        
      }
    
    }
    
</style>
